import { Link, useLocation } from "react-router-dom";
import { Train } from "lucide-react";

const TABS = [
  { path: "/", label: "Overview" },
  { path: "/invoice-capture", label: "Invoice Capture" },
  { path: "/ask-the-data", label: "Ask the Data" },
  { path: "/user-guide", label: "User Guide" },
];

export const TopNav = () => {
  const location = useLocation();

  return (
    <header className="bg-[#1D3730] shadow-[0_1px_0_rgba(255,255,255,0.08)] sticky top-0 z-50" data-testid="top-nav">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-home-link">
          <div className="w-8 h-8 rounded-md bg-[#0E6E52] flex items-center justify-center shrink-0">
            <Train className="w-4 h-4 text-white" />
          </div>
          <span className="font-display font-medium text-white text-base tracking-tight hidden sm:inline">
            KRCL Invoice &amp; Insights
          </span>
          <span
            data-testid="prototype-badge"
            className="ml-1 text-[10px] font-mono uppercase tracking-[0.15em] text-[#DCE3DF] border border-[#DCE3DF]/30 rounded-full px-2 py-0.5"
          >
            Prototype
          </span>
        </Link>
        <nav className="flex items-center gap-1">
          {TABS.map((tab) => {
            const active = location.pathname === tab.path;
            return (
              <Link
                key={tab.path}
                to={tab.path}
                data-testid={`nav-tab-${tab.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-3 sm:px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 border-b-2 ${
                  active
                    ? "bg-white/10 text-white border-[#0E6E52]"
                    : "text-[#DCE3DF] border-transparent hover:text-white hover:bg-white/5"
                }`}
              >
                {tab.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
};
